export default import.meta.ROLLDOWN_FILE_URL_DkkmEXJs9WY8hminGtE_uw